/*
 * Dropdown Controller - Create custom dropdown menus with ease.
 *
 * Usage Instructions:
 * 1. Create an unordered list (`<ul>`) element with your menu items.
 * 2. Add the class `dropdown-menu` to the list and set it as the target for this controller.
 * 3. Add a link or button to trigger the toggle event using this controller's `toggle` action.
 * 4. Use `click@window->dropdown#close` within the scope of this controller to close the menu when clicking outside of it.
 */

import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['menu'];

  connect() {
    this.isOpen = false;
  }

  toggle(evt) {
    evt.preventDefault();
    this.isOpen = !this.isOpen; // Toggle the open state
    this.menuTarget.classList.toggle('show', this.isOpen);
  }

  close(evt) {
    if (this.isOpen && !this.element.contains(evt.target)) {
      this.isOpen = false;
      this.menuTarget.classList.remove('show');
    }
  }
}
